import React from "react";

import type { RootStore } from "./RootStore";

const StoresContext = React.createContext<RootStore | null>(null);

export const StoresProvider = StoresContext.Provider;

export const useStores = () => {
  const rootStore = React.useContext(StoresContext);
  if (rootStore === null) {
    throw new Error("No RootStore found in context");
  }
  return rootStore;
};
